module.exports = __webpack_public_path__ + "static/media/time.c736cde9.svg";